import React from "react";
import Slider from 'react-slick';
import img1 from '../../Pages/Menu2/Assets/CarouselImages/destacados-1.png';
import img2 from '../../Pages/Menu2/Assets/CarouselImages/destacados-2.png';
import img3 from '../../Pages/Menu2/Assets/CarouselImages/destacados-3.png';
import img4 from '../../Pages/Menu2/Assets/CarouselImages/destacados-4.png';
import img5 from '../../Pages/Menu2/Assets/CarouselImages/destacados-5.png';
import img6 from '../../Pages/Menu2/Assets/CarouselImages/destacados-6.png';
import img7 from '../../Pages/Menu2/Assets/CarouselImages/destacados-7.png';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './Carousel.scss';

const images = [img1, img2, img3, img4, img5, img6, img7];

const Carousel = (elements) => {
  return (
    <Slider {...settings} className="container">
      {elements.elements.map((item, index) =>
        <div key={item.id}>
          <img src={images[index]} alt="Imagen de roll" />
          <div className='item-content'>
            <h3>{item.titulo}</h3>
            <span>$ {item.precio}</span>
            <p>{item.descripcion}</p>
          </div>
        </div>
      )}
    </Slider>
  );
}

  // Carousel settings
  const settings = {
    className: "center",
    centerMode: true,
    dots: true,
    arrows: false,
    infinite: true,
    centerPadding: "60px",
    slidesToShow: 3,
    speed: 400,
    slidesToScroll: 1,
    autoplay: false,
    swipeToSlide: true,
    autoplaySpeed: 10000,
    pauseOnHover: true,
    responsive: [
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 4,
          swipeToSlide: true,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 425,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  };

  export default Carousel;